export const ADMIN_ROLES = [
  'ROLE_INT_SUPER_ADMIN',
  'ROLE_CLI_ADMIN',
  'ROLE_INT_ADMIN_CLIENT',
  'ROLE_INT_ADMIN_INTERNAL',
]

export const ROLE_SYMBOLE = {
  abbreviation: 'A',
  fullCharacters: 'Administrateur',
}

export const SUPPORT_ROLES = ['ROLE_INT_SUPPORT_N1']
